import React from "react";
import { Routes, Route } from "react-router-dom";
import WishlistProvider from "./components/WishlistProvider";
import { AuthProvider } from "./contexts/AuthContext";
import Home from "./pages/Home";
import Fragrances from "./pages/Fragrances";
import Gifts from "./pages/Gifts";
import SaleNewYear from "./pages/SaleNewYear";
import BestSales from "./pages/BestSales";
import Find from "./pages/Find";
import Index from "./dashboard/Index";
import Pages from "./dashboard/pages/Pages";
import Contact from "./dashboard/pages/Contact";
import Faqs from "./dashboard/pages/Faqs";
import Testimonial from "./dashboard/pages/Testimonial";
import Category from "./dashboard/pages/Products/Category";
import Create from "./dashboard/pages/Products/Create";
import Product from "./dashboard/pages/Products/Product";
import Users from "./dashboard/pages/Users";
import Orders from "./dashboard/pages/Orders";
import Overview from "./dashboard/pages/Overview";
import AdminProfile from "./dashboard/pages/Profile";
import Subscribe from "./dashboard/pages/Subscribe";
import PrivateRoute from "./components/PrivateRoute";
import UserRoute from "./components/UserRoute";
import Profile from "./pages/auth/Profile";
import UserProfile from "./pages/auth/UserProfile";
import Wishlist from "./pages/auth/Wishlist";
import Address from "./pages/auth/Address";
import Myorder from "./pages/auth/Myorder";
import OrderDetail from "./pages/auth/OrderDetail";
import ProductDetails from "./pages/ProductDetails";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Payment from "./pages/Payment";
import Success from "./pages/Success";
import Perfume from "./pages/Perfume";
import Return from "./pages/Return";
import Privacy from "./pages/Privacy";
import Shipping from "./pages/Shipping";
import Contacts from "./pages/Contact";
import AdminRoute from "./components/AdminRoute";
import AdminLogin from "./pages/AdminLogin";
import ResetPassword from "./pages/auth/ResetPassword";
// New Pages
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import TrackOrder from "./pages/TrackOrder";
import WholesaleInformation from "./pages/WholesaleInformation";
import Sitemap from "./pages/Sitemap";
import Newsletter from "./pages/Newsletter";
import DamagePolicy from "./pages/DamagePolicy";
import RewardsProgram from "./pages/RewardsProgram";

const App = () => {
  return (
    <AuthProvider>
      <WishlistProvider>
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/auth" element={<AdminLogin />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/fragrance" element={<Perfume />} />
      <Route path="/men" element={<Fragrances />} />
      <Route path="/gift" element={<Gifts />} />
      <Route path="/new-year-sale" element={<SaleNewYear />} />
      <Route path="/unisex" element={<Fragrances />} />
      <Route path="/bestsales" element={<BestSales />} />
      {/* <Route path="/contact" element={<Find />} /> */}
      <Route path="/cart" element={<Cart />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/product_description/:id" element={<ProductDetails />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/success" element={<Success />} />
      <Route path="/return_policy" element={<Return />} />
      <Route path="/shipping" element={<Shipping />} />
      <Route path="/privacy_policy" element={<Privacy />} />
      <Route path="/contact" element={<Contacts />} />
      
      {/* New Pages */}
      <Route path="/about" element={<About />} />
      <Route path="/faqs" element={<FAQ />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/track_order" element={<TrackOrder />} />
      <Route path="/wholesale_information" element={<WholesaleInformation />} />
      <Route path="/sitemap" element={<Sitemap />} />
      <Route path="/newsletter" element={<Newsletter />} />
      <Route path="/damage" element={<DamagePolicy />} />
      <Route path="/rewards" element={<RewardsProgram />} />
      
      {/* Redirects for footer links */}
      <Route path="/account" element={<UserRoute><Profile /></UserRoute>} />
      <Route path="/wishlist" element={<UserRoute><Profile /></UserRoute>} />

      {/* Admin Routes */}
      <Route
        path="/dashboard"
        element={
          <AdminRoute>
            <Index />
          </AdminRoute>
        }
      >
        <Route index element={<Overview />} />
        <Route path="pages" element={<Pages />} />
        <Route path="contact" element={<Contact />} />
        <Route path="faqs" element={<Faqs />} />
        <Route path="testimonial" element={<Testimonial />} />
        <Route path="categories" element={<Category />} />
        <Route path="create-products" element={<Create />} />
        <Route path="products" element={<Product />} />
        <Route path="users" element={<Users />} />
        <Route path="orders" element={<Orders />} />
        <Route path="subscribe" element={<Subscribe />} />
        <Route path="profile" element={<AdminProfile />} />
      </Route>
      {/* User Profile */}
      <Route
        path="/user"
        element={
          <UserRoute>
            <Profile />
          </UserRoute>
        }
      >
        <Route index element={<UserProfile />} />
        <Route path="profile" element={<UserProfile />} />
        <Route path="favorite" element={<Wishlist />} />
        <Route path="address" element={<Address />} />
        <Route path="order_history" element={<Myorder />} />
        <Route path="order_detail/:id" element={<OrderDetail />} />
      </Route>
      </Routes>
      </WishlistProvider>
    </AuthProvider>
  );
};

export default App;
